import { useTranslation } from 'react-i18next';
import { getOptionsArrayValidation } from '@lib/utils/validationUtils';
import Select from '@lib/components/Select/Select';
import SectorOption from '@lib/components/Select/components/SectorOption';
import SectorSingleValue from '@lib/components/Select/components/SectorSingleValue';
import { FieldItem } from '@lib/interfaces/form';
import { LoadOptions } from '@lib/components/Select/types';
import SitesFilterFieldNames from '@lib/enums/fieldNames/sitesFilterFieldNames';

export const SITE_LIST_FILTER_EMPTY_VALUES = {
  [SitesFilterFieldNames.Sectors]: [],
};

type Props = {
  sectorsLoadOptions: LoadOptions;
};

export default function useSiteListFilterFields({
  sectorsLoadOptions,
}: Props): FieldItem[] {
  const { t } = useTranslation();
  return [
    {
      name: SitesFilterFieldNames.Sectors,
      label: t('sectors-label'),
      element: Select,
      validation: getOptionsArrayValidation({ t }),
      componentProps: {
        isMulti: true,
        isAsync: true,
        hasSelectAll: true,
        loadOptions: sectorsLoadOptions,
        defaultOptions: false,
        usePortal: true,
        menuPlacement: 'top',
        components: {
          Option: SectorOption,
          SingleValue: SectorSingleValue,
        },
      },
      isOptionalFn: () => false,
    },
  ];
}
